<template>
  <div class="UpdateNoticePage">
    <el-button type="primary" size="small" @click="visible = true"
      >新建公告</el-button
    >
    <el-dialog
      title="新建公告"
      :visible.sync="visible"
      width="800px"
      :center="true"
      top="50px"
      :destroy-on-close="true"
    >
      <el-form ref="form" :model="form" :rules="formRule" label-width="100px">
        <el-form-item required label="公告类型" prop="types">
          <el-radio-group v-model="form.types">
            <el-radio label="0">普通公告</el-radio>
            <el-radio label="1">质疑公告</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item prop="title" label="标题">
          <el-input
            v-model="form.title"
            placeholder="请输入公告标题"
            :maxlength="40"
          />
        </el-form-item>

        <el-form-item prop="content" label="公告内容" required>
          <!-- <el-input
            v-model="form.content"
            placeholder="请输入公告内容"
            type="textarea"
            resize="none"
            :rows="8"
          /> -->
          <div class="edit_container">
            <quill-editor
              v-model="form.content"
              ref="myQuillEditor"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @change="onEditorChange($event)"
            >
            </quill-editor>
          </div>
        </el-form-item>

        <!-- <el-form-item label="上传图片" prop="imgList">
          <el-upload
            ref="imgUpload"
            :action="`${urlss}/file/oss-upload`"
            :headers="{
              token: token,
            }"
            list-type="picture-card"
            :on-success="onImgSuccess"
            accept="image/*"
            :on-preview="handlePictureCardPreview"
          >
            <el-button size="small" type="primary">上传图片</el-button>
          </el-upload>
        </el-form-item> -->
        <el-form-item label="上传附件">
          <el-upload
            ref="attUpload"
            :action="`${urlss}/file/oss-upload`"
            :headers="{
              token: token,
            }"
            :on-success="onAttSuccess"
            accept="application/msword, application/vnd.ms-powerpoint, text/plain, application/vnd.ms-works, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          >
            <!-- 您上传的文件格式不对，请选择 pdf,doc,docx,xls,xlsx,ppt,pptx,txt,excel格式上传
            -->
            <el-button size="small" type="primary">上传附件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="发布范围" required prop="publisher">
          <el-tree
            ref="tree"
            :data="receiverLists"
            show-checkbox
            @check-change="checkChange"
            node-key="id"
            :props="{
              children: 'childList',
              label: 'name',
            }"
          ></el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submit('form')"
          >确定</el-button
        >
        <el-button size="small" @click="hideDialog">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" :center="true">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>
<script>
import { quillEditor } from 'vue-quill-editor' //调用编辑器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { pubReceiverList, UpdateNotice, urls } from '@/api/notice'
export default {
  components: {
    quillEditor,
  },
  data() {
    const checkPublisher = (rule, value, callback) => {
      const arr = Object.keys(value)
      if (arr.length === 0) {
        return callback(new Error('发布范围不能为空'))
      } else {
        callback()
      }
    }
    return {
      editorOption: {
        placeholder: '在此编辑公告内容',
      },
      token: localStorage.getItem('token'),
      schoolId: localStorage.getItem('schoolIds'),
      urlss: urls,
      form: {
        attactList: [],
        author: '',
        content: '',
        id: '',
        imgList: [],
        types: '',
        title: '',
        receiverList: [],
        publisher: {},
      },
      formRule: {
        types: [
          {
            required: true,
            message: '公告类型不能为空',
            trigger: ['change'],
          },
        ],
        title: [
          {
            required: true,
            message: '标题不能为空',
            trigger: ['blur', 'change'],
          },
          {
            max: 40,
            message: '字符串超过限制',
            trigger: 'blur',
          },
        ],
        content: [
          {
            required: true,
            message: '公告内容不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        publisher: [
          {
            type: 'object',
            validator: checkPublisher,
            required: true,
            message: '发布范围不能为空',
            trigger: ['blur', 'change'],
          },
        ],
      },
      visible: false,
      imgList: [],
      receiverLists: [],
      dialogImageUrl: '',
      dialogVisible: false,
      userId: localStorage.getItem('userId'),
      roleType: localStorage.getItem('roleType'),
      flag: true,
    }
  },
  created() {
    this.pubReceiverList()
  },
  methods: {
    // 获取树状数据
    async pubReceiverList() {
      const { data: res } = await pubReceiverList({
        schoolId: this.schoolId,
      })
      const data = res.data
      // 处理
      data.map((item) => {
        item.id = item.roleType
        item.childList.map((k) => {
          k.id = k.gradeId
          k.childList = k.classesList
          k.ClassCount = k.classesList.length
          k.parentName = item.name
          k.roleType = item.roleType

          k.childList.map((kk) => {
            kk.name = kk.title
            kk.parentName = k.name
            kk.parentId = k.gradeId
            kk.FirstName = item.name
            kk.roleType = k.roleType
          })
        })
      })
      const teacherData = res.data
      const teacherDatas = []
      // 教师数据处理
      for (let i = 0; i < teacherData.length; i++) {
        if (teacherData[i].roleType == 'teacher') {
          teacherData[i].teacherList.forEach((item) => {
            const itemData = {}
            itemData.name = item.departmentName
            itemData.id = item.departmentId
            itemData.teacherList = item.teacherList
            itemData.roleType = 'teacher'
            //  console.log('itemData',itemData);
            teacherDatas.push(itemData)
          })
        }
      }
      data.forEach((item) => {
        if (item.roleType == 'teacher') {
          item.childList = teacherDatas
        }
      })
      this.receiverLists = data
    },
    // 上传图片成功
    onImgSuccess(response, file, fileList) {
      const { data } = response
      this.form.imgList.push(...data)
    },
    onAttSuccess(response, file, fileList) {
      const { data } = response
      this.form.attactList.push(...data)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    async hideDialog() {
      this.visible = false
      this.resetForm('form')
      // this.$refs.imgUpload.clearFiles()
      this.$refs.attUpload.clearFiles()
      this.$refs.tree.setCheckedKeys([])
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },

    checkChange(data, node, childrenNode) {
      !this.form.publisher.parent
        ? (this.form.publisher = {
            parent: {
              classesList: [],
              gradeList: [],
              isAll: false,
              orgList: [],
              schoolList: [],
            },
            school: {
              classesList: [],
              gradeList: [],
              isAll: false,
              orgList: [],
              schoolList: [],
            },
            student: {
              classesList: [],
              gradeList: [],
              isAll: false,
              orgList: [],
              schoolList: [],
            },
            teacher: {
              isAll: false,
              orgList: [],
              teacherList: [],
            },
          })
        : ''
      const _arr = this.$refs.tree.getCheckedNodes()
      this.form.publisher.teacher.teacherList = []
      _arr.map((item) => {
        if (item.roleType === 'teacher') {
          console.log('item', item)
          item.teacherList.forEach((item) => {
            const idx = this.form.publisher.teacher.teacherList.indexOf(item.id)
            if (idx < 0) {
              this.form.publisher.teacher.teacherList.push(item.id)
            }
          })
          
          return false
        }

        if (item.name === '学生' || item.name === '家长') {
          if (item.childList && item.childList.length === 0) {
            this.form.publisher[item.roleType].isAll = true
          }
        } else {
          if (
            !item.parentId &&
            item.gradeId &&
            item.parentName &&
            !item.FirstName
          ) {
            if (
              this.form.publisher[item.roleType].gradeList.indexOf(
                item.gradeId
              ) < 0
            ) {
              this.form.publisher[item.roleType].gradeList.push(item.gradeId)
            }
          } else {
            if (
              this.form.publisher[item.roleType].classesList.indexOf(item.id) <
              0
            ) {
              this.form.publisher[item.roleType].classesList.push(item.id)
            }
          }
        }
      })
      if (_arr.length > this.receiverLists[2].childList.length) {
        this.form.publisher.teacher.teacherList.splice(0, 1)
      }
      console.log(this.form.publisher.teacher.teacherList)
    },

    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ApiUpdateNotice()
        } else {
          return false
        }
      })
    },
    ApiUpdateNotice() {
      const { form } = this
      let _img = [],
        _att = []
      form.imgList.map((k) => _img.push(k.fileName))
      form.attactList.map((k) => {
        _att.push({
          link: k.fileName,
          title: k.originalFilename,
          suffix: k.fileNameSuffix,
          size: k.size,
        })
      })
      form.imgList = _img
      form.attactList = _att
      form.roleType = this.roleType
      form.schoolId = this.schoolId
      form.operatorId = this.userId
      UpdateNotice({
        ...form,
      })
        .then(async (res) => {
          if (res.data.code !== '0') {
            this.$message.error('发布失败')
            return false
          }
          this.$message.success('添加成功')
          this.hideDialog()
          await this.$emit('updateData')
        })
        .catch((err) => {
          console.error(err)
        })
    },
    onEditorReady(editor) {
      // 准备编辑器
    },
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    onEditorChange() {}, // 内容改变事件
  },
  mounted() {},
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    },
  },
}
</script>
<style scoped>
.noticemanager {
  height: 100%;
  overflow: auto;
  width: 100%;
}
.notice_box {
  background-color: #ffffff;
  width: 1390px;
  margin: 20px auto;
  padding-bottom: 20px;
}
.el__tabe {
  margin-bottom: 20px;
  padding: 0 30px;
}
.el__tabe .el-tabs__header {
  margin: 0;
}
.el__tabe .el-tabs__header .el-tabs__item {
  height: 55px;
  line-height: 55px;
}
.content {
  padding: 20px;
}
.xu_content {
  margin: 0px 20px;
}

.el_card_title {
  height: 40px;
}
/* .edit_container{
  height: 300px;
} */
</style>


// WEBPACK FOOTER //
// src/views/school/components/addNotice.vue